<ng-container *ngIf="presenters.length">
	<span class="margin-right-10">{{ 'Event_Producer_Speakers' | translate }}</span>

	<span *ngFor="let presenter of presenters">
		<span [ngClass]="styles.presenter" [tooltip]="presenter.name" container="body">
			<vb-profile-picture [ngClass]="presenter.muted ? styles.muted : ''" [wrapStyle]="getShadow(presenter)" (click)="onClick(presenter)" [altTxt]="presenter.name" [profileUrl]="presenter.imgUri" [placeholderInitialsFullName]="presenter.name" size="medium">
			</vb-profile-picture>

			<span *ngIf="presenter.muted" [ngClass]="styles.muteIcon" role="img" [attr.label]="'UI_Player_Muted' | translate">

				<span class="vb-icon vb-icon-mic-off"></span>
			</span>
		</span>
	</span>
</ng-container>
